import * as React from 'react';
import HamburgerMenu from 'src/components/molecules/HamburgerMenu';
import cn from 'src/lib/cn';
import { formatMonthCalendar, formatWeekday, SATURDAY, SUNDAY, today } from 'src/lib/date';
import { useCalendarPageContext } from '../../CalendarPageContext';
import CalendarDay from './CalendarDay';
import Button from 'src/components/molecules/Button';

interface IProps {
  activeDate: Date;
  onDateSelect?: (date: Date) => void;
}

const Calendar: React.FC<IProps> = ({ activeDate, onDateSelect }) => {
  const { weeks, bookings, showWeekends, setShowWeekends } = useCalendarPageContext();

  return (
    <div className="calendar">
      <div className="calendar__title">
        <HamburgerMenu />
        {/* <ThemeToggle /> */}
        <Button onClick={() => onDateSelect && onDateSelect(new Date(activeDate.setMonth(activeDate.getMonth() - 1)))}>
          &lt;
        </Button>
        <span className="panel-title-text">{formatMonthCalendar(activeDate)}</span>
        <Button onClick={() => onDateSelect && onDateSelect(new Date(activeDate.setMonth(activeDate.getMonth() + 1)))}>
          &gt;
        </Button>
        <Button onClick={() => onDateSelect && onDateSelect(today())}>Today</Button>
        <Button onClick={() => setShowWeekends(prev => !prev)}>
          {showWeekends ? 'Hide Weekends' : 'Show Weekends'}
        </Button>
      </div>
      <div
        className={cn('calendar__grid', {
          'calendar__grid--7cols': showWeekends,
          'calendar__grid--5cols': !showWeekends,
          'calendar__grid--6rows': weeks.length === 6,
          'calendar__grid--5rows': weeks.length === 5,
        })}
      >
        {weeks[0].map((date, index) => {
          if (!showWeekends && (date.getDay() === SATURDAY || date.getDay() === SUNDAY)) {
            return null;
          }
          return (
            <div key={index} className="calendar__grid-header">
              {formatWeekday(date)}
            </div>
          );
        })}
        {weeks.map((week, index) => (
          <React.Fragment key={index}>
            {week.map(date => {
              if (!showWeekends && (date.getDay() === SATURDAY || date.getDay() === SUNDAY)) {
                return null;
              }
              return (
                <CalendarDay
                  key={date.toISOString()}
                  date={date}
                  disabled={date.getMonth() !== activeDate.getMonth()}
                  active={date.getTime() === activeDate.getTime()}
                  onClick={() => onDateSelect?.(date)}
                  bookings={bookings?.[date.toISOString()]}
                />
              );
            })}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default Calendar;
